module.exports = {"title":"Not ready to purchase?","subtitle":"We can send you an update if it goes on sale.","cta":"Yes, Send Me Updates","closeCta":"No, Thanks"}


//////////////////
// WEBPACK FOOTER
// ./src/abandonedCheckout/copy/checkoutAutoModalCopy.json
// module id = ./src/abandonedCheckout/copy/checkoutAutoModalCopy.json
// module chunks = 4